import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { getBackgroundColor, getBorderRadius, getBoxShadow, getPadding } from "./datePickerTheme";

export interface DatePickerDialogStyledProps {
    themeMode: RequiredThemeKeys;
}

export const DatePickerDialogStyled = styled("div")<DatePickerDialogStyledProps>`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    box-sizing: border-box;

    background: ${getBackgroundColor};
    box-shadow: ${getBoxShadow};
    border-radius: ${getBorderRadius};

    padding: ${getPadding};
`;
